import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { ManufacturingOrderNotification } from '../../../../core/models/manufacturing-order-notification';
import { OptionInterface } from '../../../../core/models/option.interface';
import { UserRole } from '../../../../core/models/user-role';
import { find } from '../../../../core/utils/collection.utils';
import { buildOptions } from '../../../../core/utils/option.utils';
import { formChanged } from '../../../../core/validators/form-changed.validator';
import { AbstractEditionModalForm } from '../edition-modal/abstract-edition-modal-form';

@Component({
  selector: 'app-manufacturing-order-comment-form',
  templateUrl: './manufacturing-order-comment-form.component.html',
  styleUrls: ['./manufacturing-order-comment-form.component.css'],
  providers:
    [{ provide: AbstractEditionModalForm, useExisting: forwardRef(() => ManufacturingOrderChangeFormComponent) }]
})
export class ManufacturingOrderChangeFormComponent
  extends AbstractEditionModalForm<ManufacturingOrderNotification> implements OnInit, OnChanges {
  form: AbstractControl;
  receiverOptions: OptionInterface[];
  selectedReciver: { hash: string, label: string, isRole: boolean, isUser: boolean }[] = [];
  @Input() usersRoles: UserRole[];
  @Output() searchReceiver = new EventEmitter<string>();

  constructor(
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit() {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('usersRoles')) {
      this.buildUsersRolesOptions();
    }
  }

  buildUsersRolesOptions() {
    if (this.selectedReciver && this.usersRoles) {
      const userRolesFiltered = this.usersRoles.filter(userRole => !this.selectedReciver.some(item => item.hash === userRole.hash));
      this.receiverOptions = buildOptions(userRolesFiltered, 'hash', 'name');
    }
  }

  onSelect(event) {
    if (!this.selectedReciver.some(item => item.hash === event.value)) {
      const userRole: UserRole = find(
        (ur: UserRole) => ur.hash === event.value,
        this.usersRoles
      );
      this.selectedReciver.push({
        hash: event.value,
        label: event.label,
        isRole: userRole ? userRole.isRole : null,
        isUser: userRole ? userRole.isUser : null
      });
      this.buildUsersRolesOptions();
    }
    if (this.selectedReciver.length > 0) {
      this.form.get('hasReciver').setValue(true);
    } else {
      this.form.get('hasReciver').setValue(null);
    }
    this.form.get('receiverHash').setValue('');
  }

  initForm() {
    // Receivers are optional: the comment can be saved without notifying anyone.
    // The backend persists the comment in the OF history either way.
    this.form = this.fb.group({
      hasReciver: [null],
      receiverHash: [''],
      comment: ['', [Validators.required, Validators.maxLength(255)]]
    });
  }

  removeItem(item: any) {
    const index = this.selectedReciver.indexOf(item);
    if (index !== -1) {
      this.selectedReciver.splice(index, 1);
      this.buildUsersRolesOptions();
    }
    if (this.selectedReciver.length > 0) {
      this.form.get('hasReciver').setValue(true);
    } else {
      this.form.get('hasReciver').setValue(null);
    }
  }

  updateForm(notification?: any, _params?: any) {
    if (notification && notification !== undefined) {
      const value = {
        receiverHash: notification.receiverHash,
        comment: notification.comment
      };
      this.resetForm(value);
    }
  }

  resetForm(value) {
    this.form.setValidators(formChanged(value));
    this.form.reset(value);
  }

  getFormData() {
    const formValue = this.form.value;

    return {
      receivers: this.selectedReciver.map(reciver => {
        return {
          hash: reciver.hash,
          isRole: reciver.isRole,
          isUser: reciver.isUser
        };
      }),
      comment: formValue.comment,
    };

  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/manufacturing-order-comment-form/manufacturing-order-comment-form.component.ts